define([
    './_site'
], function(
    Site
) {
    var _self;
    // console.log('menu');

    // obj
    _self = {
        menuBarToggle: function ($el) {
            var $menuBar = $('#menu-bar');

            $menuBar.toggle();
        },
        responsiveMenuBar: function (flag) {
            var $menuBar = $('#menu-bar'),
                $content = $('#content'),
                $heading = $('h1'),
                $contentHeader = $heading.closest('.section__header'),
                dropdownClass = 'section__header--dropdown';

            if (!$menuBar.length) {
                return;
            }

            if (flag) {
                if ($menuBar.prev().is('.section__header')) {
                    return;
                }
                $menuBar.hide();
                // move menu-bar
                $heading.after($menuBar);
                // set style
                $contentHeader.addClass(dropdownClass);
            } else {
                if ($menuBar.parent().is('#content')) {
                    return;
                }
                $menuBar.show();
                // move menu-bar
                $content.prepend($menuBar);
                // set style
                $contentHeader.removeClass(dropdownClass);
            }
        },
        resize: function(event) {
            var $window = $(window),
                breakpoints = Site.breakpoints;

            // md
            if ($window.width() < breakpoints.md) {
                _self.responsiveMenuBar(true);
            } else {
                _self.responsiveMenuBar(false);
            }
        }
    };


    // -------------------
    // BINDS
    // -------------------

    // ---------------- submenu
    $('body').on('click.menubar', '.section__header--dropdown', function(event) {
        _self.menuBarToggle($(this));
    });

    // ---------------- window events
    $(window).on('resize.menubar', function() {
        clearTimeout(Site.timeout.menuBarResize);
        Site.timeout.menuBarResize = setTimeout(function () {
            _self.resize();
        }, 100);
    });
    $(window).triggerHandler('resize.menubar');

    return _self;
});
